import { render, staticRenderFns } from "./GraciasEmprendedores.vue?vue&type=template&id=c23bdd24&scoped=true"
import script from "./GraciasEmprendedores.vue?vue&type=script&lang=js"
export * from "./GraciasEmprendedores.vue?vue&type=script&lang=js"
import style0 from "./GraciasEmprendedores.vue?vue&type=style&index=0&id=c23bdd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23bdd24",
  null
  
)

export default component.exports